<script>
    import Tiers from "./Tiers.svelte";
</script>

<div class="tiers-flow-wrapper flex flex-wrap flex-text-center column-direction">
    <h2 class="section-title bold flex flex-wrap">UNIX TIERS</h2>
    <section class="flex flex-wrap flex-text-center">
        <Tiers tierTitle="LEGENDARY" tierImage="./images/tiers1.png"/>
        <Tiers tierTitle="EPIC" tierImage="./images/tiers2.png"/>
    </section>
    <section class="flex flex-wrap flex-text-center shade-remover">
        <Tiers tierTitle="RARE" tierImage="./images/tiers3.png"/>
        <Tiers tierTitle="UNCOMMON" tierImage="./images/tiers4.png"/>
        <Tiers tierTitle="COMMON" tierImage="./images/tiers5.png"/>
    </section>
</div>